import { render } from "./mention.vue?vue&type=template&id=429dd086&scoped=true"
import script from "./mention.vue?vue&type=script&lang=js"
export * from "./mention.vue?vue&type=script&lang=js"

import "./mention.vue?vue&type=style&index=0&id=429dd086&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-429dd086"]])

export default __exports__